import React, { useEffect, useState } from 'react';
import { useStore } from 'zustand';
import { globalStore } from '../../stores/globalStore';
import Service from 'services/service';
import { useNavigate } from 'react-router-dom';
import "./WishList.css";
import remove from "../../assets/Images/delete.png";
import removewhite from "../../assets/Images/removeWhitw.png";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

const MyWiselist = () => {
  const { wishlistShowData, setWishlistShowData, darkMode } = useStore(globalStore);
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const navigate = useNavigate();

  const handleWishListData = async () => {
    
    try {
      const response = await Service.getWishlistService();
      if (response && response.data) {
        setWishlistShowData(response.data);
      }
    } catch (error) {
      console.error('Error fetching wishlist data:', error);
    }
  };

  const addItemToArray = (id) => {
    setSelectedProductIds((prevIds) =>
      prevIds.includes(id) ? prevIds.filter((itemId) => itemId !== id) : [...prevIds, id]
    );
  };

  const handleDeleteWishListData = async () => {
    try {
      const response = await Service.removeWishlistService({ productIds: selectedProductIds});
      if (response && response.data) {
        handleWishListData();
        showSuccessToast("Wishlist deleted successfully");
        setSelectedProductIds([]);
      }
    } catch (error) {
      console.error('Error deleting wishlist:', error);
      showErrorToast("Failed to delete wishlist");
    }
  };
  
  

  useEffect(() => {
    handleWishListData();
  }, []);

  return (
    <div className="wishlist-container">

    <div className='wishlist-header'> 
      <h1 className="wishlist-title">My Wishlist</h1>
      <button className='remove-button'>
        <img src={darkMode ? removewhite : remove} onClick={() => handleDeleteWishListData()} alt="Remove" className="remove-icon" />
      </button>

      </div>
      {wishlistShowData?.items?.length > 0 ? (
        <div className="wishlist-grid">
          {wishlistShowData.items.map((item) => (
            <div className='wishlist-main' key={item._id}>
              <div
                className="wishlist-card"
                onClick={() => navigate(`/product/${item.product._id}`)}
                style={{ cursor: 'pointer' }}
              >
                <img
                  src={item.product.primaryImage}
                  alt={item.product.name}
                  className="wishlist-image"
                />
                <div className='wishlist-detail'>
                  <h2 className="wishlist-name">{item.product.name}</h2>
                  <div className='price-details'>
                    <p className="wishlist-discount-price">₹{item.product.discountPrice}</p>
                    <p className="wishlist-price">₹{item.product.price}</p>
                    <p className="wishlist-discount">{item.product.discount} off</p>
                  </div>
                </div>
              </div>
              <label className='checkbox-container'>
                <input
                  type="checkbox"
                  onChange={() => addItemToArray(item.product._id)}
                  checked={selectedProductIds.includes(item.product._id)}
                />
                <span className='checkmark'></span>
              </label>
            </div>
          ))}
        </div>
      ) : (
        <p className="empty-wishlist">Your wishlist is empty.</p>
      )}
    </div>
  );
};

export default MyWiselist;
